<template>
  <div>
    <!--    <kanban v-if="mode==='board'"></kanban>-->
    <list v-if="mode==='list' && isLoadedRequiredData" />
  </div>
</template>

<script>
// import Kanban from "../kanban/Kanban.vue";
import listView from '../listView/listView.vue';
import LoadRequiredDataMixin from '../../mixins/LoadRequiredData';
import routerGuard from '../../router/guards';

export default {
  name: 'ListViewPage',
  components: {
    // 'kanban': Kanban,
    list: listView,
  },
  beforeRouteUpdate: routerGuard.guardListRoute,
  mixins: [LoadRequiredDataMixin],
  props: {
    mode: {
      type: String,
      default: 'list',
    },
  },
};
</script>

<style scoped>

</style>
